module.exports = __webpack_public_path__ + "media/images/trophy-2efac1db357941b463dacaaa98509f05.gif";